<template>
  <div class="core_wrap">
    <div class="core_title">核心能力</div>
    <el-row class="core_options" type="flex" justify="space-between">
      <el-col class="core_items hidden-xs-only" v-for="(item, index) in coresList" :key="'desktop-' + index"
        :class="item.isActive ? 'is_active' : ''" @click.native="changeCurrentIndex(index)">{{ item.title }}</el-col>
      <el-col class="core_items2 hidden-sm-and-up" v-for="(item, index) in coresList" :key="'mobile-' + index"
        :class="item.isActive ? 'is_active' : ''" @click.native="changeCurrentIndex(index)">{{ item.title }}</el-col>
    </el-row>
    <component :is="currentComponent[currentIndex]" :core="coresList[currentIndex] || {}"></component>
  </div>
</template>

<script>
import CoreItemOne from './CoreItemOne.vue'
import CoreItemTwo from './CoreItemTwo.vue'
import CoreItemThree from './CoreItemThree.vue'
import CoreItemFour from './CoreItemFour.vue'
import { findMainProp, findMainPropArr, transDictData, transDictDataNotType, transDictDataNotTypeMore } from '../../utils';
import Constant from '@/utils/Constant'
import { leftLikeDict } from '../../api/system';
export default {
  data() {
    return {
      coresList: [],
      currentIndex: 0,
      currentComponent: [CoreItemOne, CoreItemTwo, CoreItemThree, CoreItemFour]
    }
  },
  mounted() {
    // 初始化核心能力列表 - 业务介绍
    this.coresList.push(this.getStaticBusinessData());
    this.leftLikeDictFunc()
  },
  methods: {
    // 业务介绍的静态数据
    getStaticBusinessData() {
      return {
        title: '业务介绍',
        subTitle: '业务介绍',
        desc: '在运输专长方面，我们尤为精通化工品、危险品运输，更是熟练操作新能源汽车、钢卷、钢板、太阳能板等品名，我们拥有一支专业、娴熟的员工队伍，让原本麻烦的货运不再繁琐，事事条理清楚，简单运输，简单工作！',
        isActive: false,
        children: [
          { title: '汽车与新能源物流', content: '专为汽车行业量身定制的全球整合物流解决方案。安全、完美、出色的服务！这是整车物流的黄金守则。无论最终目的地是在赛场、车展、拍摄地或是在客户接收新车的车库。' },
          { title: '新能源物流解决方案', content: '针对储能产品出口国外的需求，我们提供全方位的普通运输服务。这包括但不限于：从生产厂家到港口的国内陆路运输，确保产品安全、准时地抵达装运地；海运或空运的国际运输安排，根据客户需求和产品特性选择最合适的运输方式；目的港的清关服务，协助客户完成报关、缴税等手续，确保货物顺利进入目标市场；以及最终的海外配送，将储能产品安全送达客户指定的海外仓库或终端用户手中。' },
          { title: '光伏组件运输', content: '我司还致力于太阳能板、组件及相关配件，通过物流渠道运往世界各地，用于安装于住宅、商业及工业领域，以促进当地的可再生能源利用和减少碳足迹。' },
          { title: '冷代干集装箱运输', content: '冷代干集装箱（NOR）是一种将冷藏集装箱（Reefer）作为普通干货集装箱使用的运输方式，不启用制冷设备。主要用于季节性舱位紧张或成本优化场景。' },
          { title: '卷钢类产品物流', content: '卷钢，钢材物流在装箱过程中，所需注意的事项包括如何处理卷钢的独特性质，如体积小、重量大且易于滚动。' }
        ],
        image: require('@/assets/img/right3 (1).png')
      };
    },
    changeCurrentIndex(index) {
      this.currentIndex = index
      this.coresList.map((v, i) => {
        i === index ? (v.isActive = true) : (v.isActive = false)
      })
    },
    async leftLikeDictFunc() {
      const res = await leftLikeDict(Constant.HOME4);
      if (res.data) {
        const back = findMainPropArr(res.data.data, Constant.HOME4)
        back.map((v, i) => {
          let transData
          if (i <= 1) {
            transData = transDictDataNotType(res.data.data.find(v => v.dictKey === `home4Title${i + 1}`).children, `home4Title${i + 1}Content`)
          } else {
            transData = transDictDataNotTypeMore(res.data.data.find(v => v.dictKey === `home4Title${i + 1}`).children, `home4Title${i + 1}Content`)
          }
          this.coresList.push({
            title: v.title,
            subTitle: v.subtitle,
            desc: v.desc,
            isActive: i === 0,
            children: transData,
            image: v.image
          })
        })

      }
    }
  }
}

</script>

<style lang="scss" scoped>
.core_wrap {
  width: 100%;
  margin-top: 50px;
  text-align: center;

  .core_title {
    color: #203040;
    font-size: 40px;
    font-weight: bold;
    padding: 30px 0;

    @media screen and (max-width: 768px) {
      font-size: 1.2rem;
    }
  }

  .core_options {
    width: 70%;
    margin: 0 auto;

    @media screen and (max-width: 768px) {
      width: 90%;
    }

    .core_items {
      width: 30%;
      height: 70px;
      border: solid 1px #04cac7;
      font-size: 30px;
      line-height: 70px;
      user-select: none;
      cursor: pointer;
      margin-bottom: 40px;
    }

    .core_items2 {
      width: 30%;
      height: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: solid 1px #04cac7;
      padding: 5px;
      font-size: 0.9rem;
    }

    .is_active {
      color: #fff;
      font-weight: bold;
      background: linear-gradient(134deg, #0649b8 1%, #0a7fd7 41%, #03d2c5 99%);
      box-shadow: 0 0.5rem 1.5rem 0 rgb(0 135 168 / 50%);
    }
  }
}
</style>
